import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { getAuth, signOut } from 'firebase/auth'

import { PURCHASE } from 'root-redux/actions/common'
import {
  PAUSE_SUBSCRIPTION,
  getPaymentDataAction,
  getUserSubscriptionsInfoUnifiedAction,
} from 'root-redux/actions/user'
import { selectActionList } from 'root-redux/selects/common'
import { TAppDispatch } from 'root-redux/store/store'

import {
  DEFAULT_PLAN_UPDATE_FAKE_DELAY,
  usePlanUpdateFakeDelay,
} from 'hooks/usePlanUpdateFakeDelay'

import { ICustomRouterState } from 'models/common.model'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

const UPGRADE_PLAN_DELAY = 12000

export const useContinuedPlan = () => {
  const { search, state } = useLocation()
  const dispatch: TAppDispatch = useDispatch()
  const fetchingActionsList = useSelector(selectActionList)
  const { isUpgrade, isPlanKept } = (state as ICustomRouterState) || {}
  const isReadyToNextStep = usePlanUpdateFakeDelay(
    isUpgrade ? UPGRADE_PLAN_DELAY : DEFAULT_PLAN_UPDATE_FAKE_DELAY,
  )

  const isPurchaseInProgress =
    fetchingActionsList.includes(PURCHASE) ||
    fetchingActionsList.includes(PAUSE_SUBSCRIPTION)

  const signOutFirebase = useCallback(() => signOut(getAuth()), [])

  const goToAccountPage = async () => {
    await dispatch(getUserSubscriptionsInfoUnifiedAction(signOutFirebase))

    if (isUpgrade) {
      dispatch(getPaymentDataAction())
    }

    goTo({
      pathname: PageId.SUBSCRIPTION_DETAILS,
      search,
    })
  }

  return {
    isInProgress: !isPlanKept && (isPurchaseInProgress || !isReadyToNextStep),
    goToAccountPage,
  }
}
